'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");

function CompanyGuestEngineModelDetailCtrl(
  $scope,
  publication,
  files,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.files = files;
  $scope.translations = translations;
  $scope.activityService = activityService;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/engine-model/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestEngineModelDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestEngineModelDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestEngineModelDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestEngineModelDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/engine-model/CompanyGuestEngineModelDetailCtrl.js
// module id = 289
// module chunks = 0